import 'css-chunksrc/client/scenes/organizationalUnitCreation/parentSelection/styles.scss';export default {
  "input": "_input_12ttn_1",
  "icon": "_icon_12ttn_15",
  "listRoot": "_listRoot_12ttn_21",
  "list": "_list_12ttn_21",
  "opened": "_opened_12ttn_36",
  "name": "_name_12ttn_45",
  "selected": "_selected_12ttn_55"
};